import {
  DocumentIcon,
  DocumentTextIcon,
  DocumentChartBarIcon,
} from '@heroicons/react/24/solid';

export function FilePath({ path }: { path: string }) {
  return (
    <span className='text-xs text-gray-500 ml-2 break-words '>{path}</span>
  );
}
export function DocIcon({
  fileName,
  isDisabled,
}: {
  fileName: string;
  isDisabled?: boolean;
}) {
  const iconClasses = `w-6 mr-2 flex-shrink-0 text-accent ${
    isDisabled ? 'opacity-50' : ''
  }`;
  const extension = /(?:\.([^.]+))?$/.exec(fileName)?.[1]?.replace(/x$/i, '');

  if (!extension) {
    return <DocumentIcon className={iconClasses} data-testid='fallback-icon' />;
  }

  const ExtMap: Record<string, React.ReactElement> = {
    doc: <DocumentTextIcon className={iconClasses} />,
    pdf: <DocumentIcon className={iconClasses} />,
    xls: (
      <DocumentChartBarIcon
        className={iconClasses}
        data-testid='doc-chart-bar-icon'
      />
    ),
  };

  return ExtMap[extension] ?? <DocumentIcon className={iconClasses} />;
}
